/* eslint-disable */
const ls = require('local-storage');

import * as types from './mutation-types';

export default {
  /**
   * Login
   */
  [types.LOGIN](state, { shopToken, shop }) {
    state.authenticated = true;
    state.shop = shop;
    state.shopToken = shopToken;
    ls.set('shopToken', shopToken);
  },
  [types.RESET](state) {
    state.authenticated = false;
    state.shop = null;
    state.shopToken = null;
    ls.clear();
  },
  /**
   * Update shop data
   */
  [types.UPDATE_SHOP](state, shop) {
    /**
     * Set shop to null allows to be sure that changes are detected by the scope
     */
    state.shop = null;
    state.shop = shop;
  },
  shopName(state, shopName) {
    state.shopName = null;
    state.shopName = shopName;
  },

  [types.INFO_SHOP](state, shopInfo) {
    state.shopInfo = null;
    state.shopInfo = shopInfo;
  }
};
